/* import __COLOCATED_TEMPLATE__ from './topic-stamp.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */

import templateOnlyComponent from '@ember/component/template-only';
import type { TrendingTopic } from 'embercom/components/reporting/automation/fin-ai-agent/analyze/topic-trends/trending-topics-data-resources';

interface Signature {
  Args: {
    trendingTopic: TrendingTopic;
  };
}

const TopicStamp = templateOnlyComponent<Signature>();
export default TopicStamp;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::FinAiAgent::Analyze::TopicTrends::TopicStamp': typeof TopicStamp;
  }
}
